import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Heading from "../Products/Heading";
import Product from "../Products/Product";

import SampleNextArrow from "../NewArrivals/SampleNextArrow";
import SamplePrevArrow from "../NewArrivals/SamplePrevArrow";
import { jimikiDropsEaringStudsList, SplOfferData } from "../../../constants/index";
import { getNecklaceProductData } from "../../../api/Api";

const Sliver = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const loadData = () => {
    setLoading(true);
    getNecklaceProductData("orgData@gmail.com", "JimikiDropsEaringStuds")
      .then((res) => {
        const responseData = res.data;

        // Update `chain` array with response data
        responseData.forEach((responseItem) => {
          const chainItem = jimikiDropsEaringStudsList.find(item => item._id === responseItem._id);
          if (chainItem) {
            chainItem.des = responseItem.des;
            chainItem.price = responseItem.price;
            chainItem.productName = responseItem.productName;
            chainItem.wastage = responseItem.wastage;
            chainItem.weight = responseItem.weight;
          }
        });

        setData(jimikiDropsEaringStudsList);
        console.log("Updated data:", SplOfferData);
      })
      .catch((error) => {
        if (error.message) {
          console.error("Error message:", error.message);
        } else {
          console.error("Sorry! Something went wrong.");
        }
      })
      .finally(() => {
        setLoading(false); // Ensures loading is turned off after the request completes
      });
  };
  useEffect(() => {
    loadData();
  }, []);
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };
  return (
    <div className="w-full pb-16">
      <Heading heading="jimikiDropsEaringStuds" />
      <Slider {...settings}>
        {
          data?.map((product, index) => {
            return (
              <div key={index} className="px-2">
                <Product
                  _id={product._id}
                  img={product?.img}
                  category={product.category}
                  productName={product.productName}
                  price={product.price}
                  color={product.color}
                  size={product.size}
                  weight={product.weight}
                  badge={product.badge}
                  des={product.des}
                  video={product.video}
                  wastage={product.wastage}
                  goldRateWhileOnboard={product.goldRateWhileOnboard}
                  onboardDate={product.onboardDate}
                  designName={product.designName}
                  stockType={product.stockType}
                  pgjWastage={product.pgjWastage}
                />
              </div>
            )
          })
        }

      </Slider>
    </div>
  );
};

export default Sliver;
